// CounterUp2 exports a default function, so we need to get the default export 
// from the ES6 module without using import statements.
const counterUp = window.counterUp.default;

$(document).ready(function () {
    // Function to set the width dynamically
    function setDynamicWidth() {
        $('.js-count-up').each(function() {
            var $this = $(this);
            var originalContent = $this.text();

            // Create a temporary element to measure the width
            var $tempElement = $('<span>').text(originalContent).css({
                'font-family': $this.css('font-family'),
                'font-size': $this.css('font-size'),
                'visibility': 'hidden',
                'white-space': 'nowrap'
            }).appendTo('body');

            // Get the width of the temporary element
            var width = $tempElement.width();

            // Set the width of the counter element
            $this.css('width', width + 'px');

            // Remove the temporary element
            $tempElement.remove();
        });
    }

    // Call the function to set width before counter-up starts
    setDynamicWidth();

    $('.js-count-up').each(function () {
        $(this).attr('width', $(this).width());
        $(this).css('width', $(this).width() + 'px !important');
        $(this).css('max-width', $(this).width() + 'px !important');
    });

    // Watches for elements that become visible in the viewport. Works for scrolling the page,
    // and the slick sliders (checks transformations too).
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Trigger the counterUp only when the element is in view
                counterUp(entry.target, {
                    delay: 10,
                    time: 1000
                });
                // observer.unobserve(entry.target); // Optionally unobserve the element to avoid re-triggering
            }
        });
    }, {
        threshold: 0.5 // Trigger when at least 50% of the element is visible
    });

    // Observe all elements with the class .js-count-up
    $('.js-count-up').each(function () {
        observer.observe(this);
    });
});
